import { Body, ButtonContainer, Empty } from "../../style"
import { FC, useCallback, useState } from "react";
import { useMobilePlace } from "widgets/mobileIndex/lib/hooks/useMobilePlace";
import { Hall } from "../hall";
import { Loader } from "../loader";
import { Form } from "../form";
import { ModalProvider } from "shared/ui/modal";
import { Confirm } from "shared/ui/confirm";
import { ButtonContained } from "shared/ui/buttons/buttonContained";
import { ButtonOutlined } from "shared/ui/buttons/buttonOutlined";
import { Flex } from "shared/ui/flex";

interface MobileIndexPlaceProps {
  isLoaded: boolean
}

export const MobileIndexPlace: FC<MobileIndexPlaceProps> = ({
  isLoaded,
}) => {
  const [ isOpen, setIsOpen ] = useState<boolean>(false);

  const {
    control,
    renderTables,
    isLoading,
    setValue,
    getValues,
    setTables,
    onTableClick,
    activeTables,
    isHandMode,
    setIsHandMode,
    buttonDisabled,
    onBook,
    minDuration,
    loadFreeSlots,
    noTablesText
  } = useMobilePlace(isLoaded);

  const Btn = () => {
    if (isHandMode) {
      return (
        <ButtonContained onClick={onHandModeClick}>
          Ручное бронирование
        </ButtonContained>
      )
    }

    return (
      <ButtonOutlined onClick={onHandModeClick}>
        Ручное бронирование
      </ButtonOutlined>
    )
  }

  const onHandModeClick = useCallback(() => {
    if (isHandMode) {
      setIsHandMode(false);
    } else {
      setIsOpen(true)
    }
  }, [isHandMode, setIsHandMode, setIsOpen])

  const onClose = useCallback(async ()=>{
    setIsOpen(false);
    setTables();
  }, [setIsOpen, setTables])

  const toggleHandMode = useCallback(async ()=>{
    setIsHandMode(true);
    setIsOpen(false);
  }, [setIsHandMode, setIsOpen])
  
  if (!isLoading) {
    if (renderTables?.length) {
      return (
        <>
          <Body>
            <Form 
              getValues={getValues}
              setValue={setValue}
              setTables={setTables}
              control={control}
              minDuration={minDuration}
              loadFreeSlots={loadFreeSlots}
            />
            {
              isHandMode && 
              <Flex
                $padding="0 15px"
                $margin="0 0 32px 0"
              >
                <Btn />
              </Flex>
            }
            {
              renderTables.map((hall, index) => {
                return (
                  <Hall 
                    key={index}
                    name={hall.name}
                    items={hall.items}
                    onTableClick={onTableClick}
                    activeTables={activeTables}
                    control={control}
                  />
                )
              })
            }

            <ButtonContainer>
              <ButtonContained disabled={buttonDisabled} onClick={onBook}>
                Разместить
              </ButtonContained>
            </ButtonContainer>
          </Body>
        </>
      )
    }

    return (
      <>
        <Body>
          <Form 
            getValues={getValues}
            setValue={setValue}
            setTables={setTables}
            control={control}
            minDuration={minDuration}
            loadFreeSlots={loadFreeSlots}
          />
          <Flex
            $padding="0 15px"
          >
            <Btn />
          </Flex>

          <Empty>{noTablesText}</Empty>
          
          {isOpen && 
          <ModalProvider openByDefault>
            <Confirm
              title="Действительно отключить все правила для этого бронирования?"
              cancelButtonLabel='Нет, продолжить с проверками'
              confirmButton={
                <ButtonContained onClick={toggleHandMode}>
                  Да, отключить
                </ButtonContained>
              }
              onClose={onClose}
            />
          </ModalProvider>
          }

            <ButtonContainer>
              <ButtonContained disabled={buttonDisabled} onClick={onBook}>
                Разместить
              </ButtonContained>
            </ButtonContainer>
        </Body>
      </>
    )
  }

  return (
    <Body>
      <Loader />
    </Body>
  )
}